import React, { useState } from "react";
import { faqs } from "../../components/faqs/data";
import "./style.css";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faqs">
      <div className="faq-container">
        <div className="title">
          <h1>
            Frequent Asked <span className="title-word">Questions</span>
          </h1>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleAccordion(index)}
              >
                <h2 className="faq-index">
                  {index + 1}. {faq.question}
                </h2>
                <h6 className="faq-toggle-icon">
                  {activeIndex === index ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="56"
                      height="56"
                      viewBox="0 0 56 56"
                      fill="none"
                    >
                      <path
                        d="M40.1227 34.5439C39.3422 35.3243 38.0771 35.325 37.2958 34.5454L29.4127 26.6795C28.632 25.9005 27.368 25.9005 26.5873 26.6795L18.7042 34.5454C17.9229 35.325 16.6578 35.3243 15.8773 34.5439L15.4142 34.0808C14.6332 33.2997 14.6332 32.0334 15.4142 31.2523L26.5858 20.0808C27.3668 19.2997 28.6332 19.2997 29.4142 20.0808L40.5858 31.2523C41.3668 32.0334 41.3668 33.2997 40.5858 34.0808L40.1227 34.5439Z"
                        fill="black"
                        fillOpacity="0.8"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="56"
                      height="56"
                      viewBox="0 0 56 56"
                      fill="none"
                    >
                      <path
                        d="M15.6459 21.6871C16.5542 20.7788 18.0266 20.778 18.9359 21.6853L25.1747 27.9104C26.736 29.4684 29.264 29.4684 30.8253 27.9104L37.0641 21.6853C37.9734 20.778 39.4458 20.7788 40.3541 21.6871C41.2631 22.5961 41.2631 24.0699 40.3541 24.9789L30.8284 34.5045C29.2663 36.0666 26.7337 36.0666 25.1716 34.5045L15.6459 24.9789C14.7369 24.0699 14.7369 22.5961 15.6459 21.6871Z"
                        fill="black"
                        fillOpacity="0.8"
                      />
                    </svg>
                  )}
                </h6>
              </div>
              <div
                className={`faq-answer ${activeIndex === index ? "open" : ""}`}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
